module.exports = __webpack_public_path__ + "img/vQR_f.7c32be33.png";